import 'select2';
import 'select2/dist/css/select2';
import '../entrypoints/src/admin/jquery_plugins/dynamic_option_select2';

import LocationService from '../entrypoints/src/admin/services/batch-location-service';
import LevelService from '../entrypoints/src/admin/services/level-service';
import sweet_alert from "../entrypoints/src/admin/utilities/sweet_alert";

import { Controller } from "stimulus";
import BatchService from '../entrypoints/src/admin/services/batch-service';

export default class extends Controller {
  static targets = [ 'fixedValueContainer', 'dynamicValueContainer', 'level', 'location', 'batchValue', 'basicFields', 'curriculumFields' ];

  initialize() {
    this.bindingSelect2(this.levelTarget, LevelService, 'Nível/Módulo');
    this.bindingSelect2(this.locationTarget, LocationService, 'Local');

    $('.batch-service.select2').select2({
      placeholder: '-- selecione --',
      multiple: false,
      allowClear: false,
      escapeMarkup: (markup) => markup,
      dropdownParent: this.element.querySelector('.modal.modal-body')
    }).on('change', (e) => {
      this.handleServiceChange(e);
    });
  }

  connect() {
    $('input[name="batch[fixed_value]"]:checked').each(function() { this.dispatchEvent(new Event('change')) });
    this.tag = "[BatchController]";

    this.watchAttributesOptions();
    this.handleInitialServiceModel();

    console.log(this.tag, "Connected");
  }

  saveLessonsClasses(ev) {
    ev.preventDefault();
    document.querySelector('.save-lessons-classes').click()
  }

  watchAttributesOptions() {
    const observer = new MutationObserver((_) => {
      if (typeof this.element.dataset.attributes === 'undefined')
        return;

      let attributes = JSON.parse(this.element.dataset.attributes);
      this.updateBatchFrom(attributes);
      attributes.map((el) => el.name = `${this.element.dataset.objectName}[${el.name}]`);

      [...this.element.querySelectorAll('.wrapper-attributes')].forEach(($el) => $el.remove());
      this.element.insertAdjacentHTML('afterbegin', `<div class="wrapper-attributes">${attributes.map((attribute) => this.inputHtml(attribute)).join('')}</div>`);
    });
    observer.observe(this.element, { attributes: true });
  }

  updateBatchFrom(attributes) {
    let flexibleSchedules = attributes.find((el) => el.name == 'flexible_schedules');
    if (!!flexibleSchedules && flexibleSchedules.hasOwnProperty('value'))
      this.hasBatchValueTarget && this.batchValueTarget.closest('.wrapper-form-group').classList.toggle('hidden', flexibleSchedules.value);
  }

  updateValues(ev) {
    let element = ev.target,
      input = this.batchValueTarget;

    if (!input)
      return sweet_alert.fire('Espera!', 'Referência inválida', 'error');

    sweet_alert.fire({
      customClass: {
        cancelButton: 'btn btn-gray-primary mx-2',
        confirmButton: 'btn btn-green-500 mx-2'
      },
      buttonsStyling: false,
      title: 'Atenção',
      html: "Tem certeza que deseja atualizar todos os contratos relacionados a essa frequência? <br><br> <strong>Nota:</strong> Todas as faturas em aberto serão atualizadas.",
      type: 'warning',
      animation: false,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, atualizar contratos e faturas'
    }).then(async (result) => {
      if (result.value) {
        try {
          await BatchService.updateValues(element.dataset.valueId, { value: input.value });

          sweet_alert.fire({
            title: 'Contratos Atualizados',
            html: `Todos os contratos realicionados a essa turma, foram atualizados`,
            heightAuto: false,
            type: 'success',
            animation: true,
            showCancelButton: false,
            confirmBUttonText: 'Ok!'
          });

          element.classList.toggle('hidden', true);
        } catch (ex) {
          console.log(ex)
          sweet_alert.fire('Opa!', 'Não foi possível atualizar os contratos relacionados', 'error');
        }
      }
    });
  }

  toggleTarget(ev) {
    this.element.querySelector(ev.currentTarget.dataset.target).classList.toggle('d-none');
  }

  bindingSelect2($selectElement, model, itemTypeName) {
    $($selectElement)
      .select2()
      .dynamicOption({
        text: `+ Novo ${itemTypeName}`,
        modalTitle: `Novo ${itemTypeName}`,
        modalLabelName: `Nome do ${itemTypeName}`,
        saveItem: async (name, id) => {
          let resources = itemTypeName == 'Nível/Módulo' ? { level: { name: name } } : { location: { name: name } };
          let modelIdentification = !id ? await model.create(resources) : await model.update(id, resources);
          return modelIdentification.id;
        },
        removeItem: async (id) => { return await model.destroy(id) },
      });
  }

  // stimulus-events
  fixedValueChanged(ev) {
    let isFixedValue = ev.currentTarget.checked && ev.currentTarget.value === 'true';
    this.fixedValueContainerTargets.forEach(($el) => $el.classList.toggle('hidden', !isFixedValue));
    this.dynamicValueContainerTargets.forEach(($el) => $el.classList.toggle('hidden', isFixedValue));
  }

  inputHtml(options) {
    return `<input type="${options['type']}" name="${options['name']}" value="${options['value']}">`;
  }

  // Service model detection methods
  handleInitialServiceModel() {
    const serviceSelect = this.element.querySelector('.batch-service');

    if (serviceSelect && serviceSelect.value) {
      this.updateFormForServiceModel(serviceSelect);
    }
  }

  handleServiceChange(event) {
    this.updateFormForServiceModel(event.target);
  }

  updateFormForServiceModel(selectElement) {
    const selectedOption = selectElement.querySelector(`option[value="${selectElement.value}"]`);
    if (!selectedOption) return;

    const model = selectedOption.dataset.model;
    const isFlexibleSchedules = selectedOption.dataset.flexibleSchedules === 'true';

    this.toggleFieldsByModel(model, isFlexibleSchedules);
  }

  toggleFieldsByModel(model, isFlexibleSchedules) {
    const isBasic = model === 'basic';
    const isCurriculum = model === 'curriculum';

    // Toggle field visibility based on model
    if (this.hasBasicFieldsTarget) {
      this.basicFieldsTarget.classList.toggle('d-none', !isBasic);
    }

    if (this.hasCurriculumFieldsTarget) {
      this.curriculumFieldsTarget.classList.toggle('d-none', !isCurriculum);
    }

    // Handle value field visibility based on model and flexible schedules
    if (this.hasBatchValueTarget) {
      const shouldHideValue = isBasic && isFlexibleSchedules;
      this.batchValueTarget.closest('.wrapper-form-group').classList.toggle('hidden', shouldHideValue);
    }
  }
}
